module.exports = __webpack_public_path__ + "img/china-sinopec-card-bg.8d3a7098.png";